module.exports = __webpack_public_path__ + "img/body-1.b98e89c6.png";